import React from "react";
import { components, OptionProps } from "react-select";

import { StatusText } from "shared/styles";
import { StyledOption } from "../styles";

export const Option: React.FC<OptionProps<any>> = ({ children, ...props }) => {
  const { data } = props;
  const { handleClick, status } = data;

  return handleClick ? (
    <StyledOption
      as="button"
      type="button"
      onClick={() => handleClick(data.value)}
      data-testid={data.dataTestId || data.value}
    >
      <components.Option {...props}>
        <StatusText status={status}>{children}</StatusText>
      </components.Option>
    </StyledOption>
  ) : (
    <StyledOption data-testid={data.dataTestId || data.value}>
      <components.Option {...props}>
        <StatusText status={status}>{children}</StatusText>
      </components.Option>
    </StyledOption>
  );
};
